<template>
    <div class="flex mt-3">
        <div
            class="pt-2 pb-3 px-4 cursor-pointer text-white mr-2 flex-1 text-center text-sm border-b-4 font-medium font-main-medium"
            :class="[active == 'detail' ? 'text-gold-lighten-1 border-gold-lighten-1' : 'text-dark-5 border-transparent']"
            data-cy="btn_detail_condition_tab_detail"
            @click="clickTab('detail')"
        >{{ lbl.detail.detail }}</div>
        <div
            class="pt-2 pb-3 px-4 cursor-pointer text-white flex-1 text-center text-sm border-b-4 font-medium font-main-medium"
            :class="[active == 'condition' ? 'text-gold-lighten-1 border-gold-lighten-1' : 'text-dark-5 border-transparent']"
            data-cy="btn_detail_condition_tab_condition"
            @click="clickTab('condition')"
        >{{ lbl.detail.condition }}</div>
    </div>
    <div class="pt-3 text-dark-6 text-sm">
        <div v-show="active == 'detail'" v-html="detailText" data-cy="text_detail_condition_detail_content"></div>
        <div v-show="active == 'condition'" v-html="conditionText" data-cy="text_detail_condition_condition_content"></div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailAndCondition",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    data: function () {
        return {
            active: 'detail', // detail, condition

            detailText: null,
            conditionText: null,
        };
    },
    created: function () {
        let detail = this.campaign.detail
        let condition = this.campaign.condition
        if (this.localeCode == 1033) {
            detail = this.campaign.detailEn
            condition = this.campaign.conditionEn
        }
        this.detailText = Util.newLineToBr(detail);
        this.conditionText = Util.newLineToBr(condition);
    },
    methods: {
        clickTab: function (active) {
            this.active = active;
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
